import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShiftApiModel, SyncWithPlatformResultApiModel } from '@app/api/api-models';
import { CrudService } from '../crud.service';

@Injectable()
export class ShiftsService extends CrudService<ShiftApiModel, number> {
  public apiUrl = 'shifts';

  public syncWithPlatform(): Observable<SyncWithPlatformResultApiModel> {
    return this.http.post<SyncWithPlatformResultApiModel>(`${this.apiUrl}/sync-with-platform`, {});
  }
}
